import type { PromoCampaignTemplateRowModel } from '../model/types'

export default async function buildPromoImportTemplateBlob(
	rows: PromoCampaignTemplateRowModel[]
): Promise<Blob> {
	const Excel = await import('exceljs')
	const workbook = new Excel.Workbook()
	workbook.creator = 'Competera'
	const worksheet = workbook.addWorksheet('Sheet1')
	worksheet.columns = [
		'sku',
		'title',
		'discount_price',
		'discount_percent',
		'discount_sum',
		'predicted_growth_rate',
	].map((key) => ({ header: key, key, width: 50 }))
	worksheet.addRows(rows)
	const buffer = await workbook.xlsx.writeBuffer()

	return new Blob([buffer], {
		type: 'application/octet-binary;charset=utf-8',
	})
}
